import { cn } from "@/lib/utils";

interface WaveDividerProps {
  className?: string;
  flip?: boolean;
  palette?: "contact" | "site";
}

export function WaveDivider({
  className,
  flip = false,
  palette = "contact",
}: WaveDividerProps) {
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none w-full",
        palette === "site"
          ? "text-[var(--site-surface-alt)]"
          : "text-[var(--contact-section-bg)]",
        flip && "rotate-180",
        className
      )}
    >
      <svg viewBox="0 0 1440 48" preserveAspectRatio="none" className="block h-8 w-full md:h-12">
        <path
          fill="currentColor"
          d="M0,24 C240,48 480,0 720,24 C960,48 1200,0 1440,24 L1440,48 L0,48 Z"
        />
      </svg>
    </div>
  );
}
